//import React, { useState} from 'react'

const Map = () => {
	  
  return (
	<div className="w-full flex justify-center">
		<iframe title="CSSS mapka" className="md:w-[550px] md:h-[300px] overflow-hidden" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2555.283958482041!2d12.647151976816417!3d50.17452690719227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a0921fe6bd5c01%3A0xa6ed104c0da729a1!2sJ.%20z%20Pod%C4%9Bbrad%202046%2C%20356%2001%20Sokolov%201!5e0!3m2!1scs!2scz!4v1735989985531!5m2!1scs!2scz" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
	</div>
  )
}

export default Map
